(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!Carousel.SlidesToScroll) {
    return;
  }

  class ScrollSnaps {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
    }

    /**
     * Initializes the carousel scroll snaps with the provided state.
     * Sets up the internal state and initializes the SlidesToScroll instance.
     *
     * @param {Object} state - The state object containing carousel configuration.
     * @returns {this} The current instance for chaining.
     */
    initialize(state) {
      this.state = state;
      this.slidesToScroll = new Carousel.SlidesToScroll();
      this.slidesToScroll.initialize(state);
      return this;
    }

    /**
     * Calculates the unaligned snap positions for each slide relative to the container.
     *
     * For each slide, computes the distance from the container's start edge to the slide's start edge,
     * then returns the negative absolute value of that distance. This is typically used to determine
     * how much each slide overflows or underflows the container in the scrolling direction.
     *
     * @returns {number[]} An array of negative absolute distances from the container's start edge to each
     * slide's start edge.
     */
    measureUnaligned() {
      const axis = this.state.get('axis');
      const containerRect = this.state.get('containerRect');
      const slideRects = this.state.get('slideRects');
      const startEdge = axis.getStartEdge();

      return slideRects.map((rect) => containerRect[startEdge] - rect[startEdge]).map((snap) => -Math.abs(snap));
    }
  }

  global.NewHomeSource.Carousel.ScrollSnaps = ScrollSnaps;
}(window));
